import api from 'api';

// Evergreen Sponsor. Called on the raw axios instance, like api/newsroom.js,
// so the API's message and status reach the page.

const unwrap = (res) => res.data.data;

// The slug comes from the URL, so it must not be able to steer the request elsewhere.
export const alertIdFromSlug = async (slug) => {
    const alert = unwrap(
        await api.get(`/alerts/slug/${encodeURIComponent(slug)}`)
    );
    if (!Number.isInteger(alert?.id)) throw new Error('Alert not found');
    return alert.id;
};

// The Stripe Checkout URL for a responder buying the slot. 409 when it is gone.
export const startFaqSponsorCheckout = async (slug) =>
    (
        await api.post(
            `/stripe/checkout/session/faq-sponsor/${await alertIdFromSlug(
                slug
            )}`
        )
    ).data;

export const startFaqSponsorRenewal = async (slug) =>
    (
        await api.post(
            `/stripe/checkout/session/faq-sponsor/${await alertIdFromSlug(
                slug
            )}/renewal`
        )
    ).data;

export const fetchSponsorForm = async (alertId) =>
    unwrap(await api.get(`/faq-sponsor/${alertId}`));

export const submitSponsorAnswers = async (alertId, body) =>
    unwrap(await api.put(`/faq-sponsor/${alertId}/answers`, body));

export const fetchSponsorships = async ({ page = 1, size = 20 } = {}) =>
    unwrap(await api.get('/faq-sponsor', { params: { page, size } }));

export const editSponsorAnswers = async (alertId, body) =>
    unwrap(await api.put(`/faq-sponsor/${alertId}/review`, body));

export const approveSponsorAnswers = async (alertId) =>
    unwrap(await api.post(`/faq-sponsor/${alertId}/approve`));

export const declineSponsorAnswers = async (alertId, reason) =>
    unwrap(await api.post(`/faq-sponsor/${alertId}/decline`, { reason }));
